import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { formatCruiseTravellerTypeLabel } from 'constants/cruise'

function useCruiseTravellerTypeLabel() {
  const intl = useIntl()

  return useCallback((travellerType?: string): string | undefined => {
    return formatCruiseTravellerTypeLabel(intl, travellerType)
  }, [intl])
}

export default useCruiseTravellerTypeLabel
